import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "../styles/layout/LanguageSwitcher.module.css";

const languages = ["lv", "en", "ru", "de", "fr", "es", "lt", "est"];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language || "en");
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null); // ref для всей обёртки

  const toggleList = () => setOpen(!open);

  const handleSelect = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLang(lng);
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleList();
    }
  };

  useEffect(() => {
    if (i18n.language !== currentLang) {
      setCurrentLang(i18n.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);
  

  // Закрытие по клику вне
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <div ref={wrapperRef} className={styles.wrapper}>
       {/* Переключатель с доступностью */}
       <div
        onClick={toggleList}
        onKeyDown={handleKeyDown}
        className={`${styles.toggleLabel} ${open ? styles.active : ""}`}
        role="button"
        tabIndex={0}
        aria-label={`Current language: ${currentLang.toUpperCase()}. Click to change language.`}
      >
        <motion.span
          className={styles.icon}
          animate={{ left: open ? 42 : 5 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          <span className={styles.langCode}>{currentLang.toUpperCase()}</span>
        </motion.span>
      </div>

      {open && (
        <ul className={styles.dropdown}>
        {languages.map((lng) => (
          <li key={lng} onClick={() => handleSelect(lng)}>
            <div className={`${styles.languageToggle} ${
                currentLang === lng ? styles.active : ""
            }`}
            >
              <motion.div
                className={styles.languageIcon}
                animate={{ left: currentLang === lng ? 42 : 5 }}
                transition={{ type: "spring", stiffness: 300, damping: 18 }}
              >
                <span className={styles.languageText}>{lng.toUpperCase()}</span>
              </motion.div>
            </div>
          </li>
        ))}
      </ul>
      
      )}
    </div>
  );
}

export default LanguageSwitcher;
